// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3ki2t","footer":"Form_footer__10_eh"};